export default __webpack_public_path__ + "static/media/calendar.5b1359ff.svg";